export default __webpack_public_path__ + "static/media/react.430bce8a.svg";